// this function is needed to manage JSON responses to timeseries queries, since the needed values can be nested in arrays

export const findNonArrayValuesInLastElement = (value) => {
  // Store the current array or value
  let lastArray = value;

  while (Array.isArray(value) && value.length > 0) {
    // Update the lastArray to the current value before drilling down
    lastArray = value;
    // Drill down to the last element of the current array
    value = value[value.length - 1];
  }

  // If the last value is an object, return it
  if (typeof value === "object" && value !== null) {
    return value;
  }

  // Otherwise, return the last array
  return lastArray;
};
